import React, {useCallback} from 'react'
import styles from './FilterButton.module.css'
import { FilterButtonProps } from '../../types'

export const FilterButton: React.FC<FilterButtonProps> = ({
                                                              item,
                                                              selectedValue,
                                                              onFilterChange,
                                                              filterType,
                                                              dataClickLabel
                                                          }) => {
    const isSelected = selectedValue === item

    const handleClick = useCallback(() => {
        onFilterChange(filterType, item)
    }, [onFilterChange, filterType, item])

    return (
        <button
            onClick={handleClick}
            className={`${styles.baseButton} ${isSelected ? styles.selected : styles.default}`}
            type={'button'}
            data-click-label={dataClickLabel}
        >
            {item}
        </button>
    )
}
